import React from 'react';
import { array } from 'prop-types';

import '../styles/AboutUs.css';

function AboutUs({ descriptions }) {
    return (
        <div
            className={'about-us'}
        >
            {descriptions.map(({ question, answers }) => (
                <div
                    key={question}
                >
                    <h3
                        className={'about-us-question'}
                    >
                        {question}
                    </h3>
                    {answers.map((answer) => (
                        <p
                            key={answer}
                            className={'about-us-answer text-muted'}
                        >
                            {answer}
                        </p>
                    ))}
                </div>
            ))}
        </div>
    );
}

AboutUs.propTypes = {
    descriptions: array,
};

export default AboutUs;